import React from "react";

import LocationIcon from "../../assets/img/icons/location_icon.svg";
import {
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
} from "../../styledComponents/common";

const LocationDisplay = ({ locations = [], onClick }) => {
  if (!locations || locations.length === 0) {
    return (
      <CommonText margin="0px" fontSize="14px">
        -
      </CommonText>
    );
  }

  const defaultLocation = locations.find(loc => loc.default === true);
  const primaryLocation = defaultLocation || locations[0] || null;
  const additionalLocationsCount =
    locations.length > 1 ? locations.length - 1 : 0;

  if (!primaryLocation) {
    return (
      <CommonText margin="0px" fontSize="14px">
        -
      </CommonText>
    );
  }

  return (
    <CommonGrid
      gap="4px"
      columns="20px 1fr"
      style={{
        alignItems: "flex-start",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <CommonImage
        src={LocationIcon}
        alt="location"
        style={{ marginTop: "2px" }}
      />
      <CommonFlex
        gap="4px"
        // style={{ flexWrap: "wrap", alignItems: "baseline" }}
        direction="column"
        alignItems="flex-start"
      >
        <CommonText
          margin="0px"
          fontSize="14px"
          style={{
            color: "#2F394E",
            lineHeight: "20px",
          }}
        >
          {primaryLocation.address}
        </CommonText>
        {additionalLocationsCount > 0 && (
          <CommonText
            margin="0px"
            fontSize="13px"
            style={{
              color: "#2F394E",
              lineHeight: "20px",
            }}
          >
            +{additionalLocationsCount} more location
            {additionalLocationsCount > 1 ? "s" : ""}
          </CommonText>
        )}
      </CommonFlex>
    </CommonGrid>
  );
};

export default LocationDisplay;
